export type BrandId = 'ag' | 'hid';

const VALID_BRANDS: BrandId[] = ['ag', 'hid'];

function resolveBrand(raw: string | undefined): BrandId {
  if (raw === 'hid') return 'hid';
  return 'ag';
}

/** Brand baked in at build/dev time. Defaults to `ag`; use `vite --mode hid` for HID. */
export const APP_BRAND: BrandId = resolveBrand(import.meta.env.VITE_BRAND);

export function isBrandId(value: string): value is BrandId {
  return VALID_BRANDS.includes(value as BrandId);
}
